module.exports = __webpack_public_path__ + "img/tsjersey.23733c45.svg";